export function getSubdomain() {
  const host = window.location.hostname.toLowerCase();

  // 1. Localhost and raw IP root
  if (host === "localhost" || host === "127.0.0.1") {
    return "";
  }

  // 2. Staging domain with school subdomain prefix
  // e.g. "delhi-public.staging.yuvaquest.com" or "delhi-public.staging.localhost"
  if (host.includes(".staging.")) {
    const prefix = host.split(".staging.")[0];
    const sub = prefix.split(".").pop();
    const reserved = ["www", "admin", "app", "staging"];
    return reserved.includes(sub) ? "" : sub;
  }

  // 3. Staging root domain (no preceding school subdomain)
  // e.g. "staging.yuvaquest.com", "staging.localhost"
  if (host === "staging.yuvaquest.com" || host.startsWith("staging.")) {
    return "";
  }

  // 4. Localhost with subdomain (e.g. "delhi-public.localhost")
  if (host.endsWith(".localhost")) {
    const sub = host.replace(".localhost", "").split(".").pop();
    const reserved = ["www", "admin", "app", "staging"];
    return reserved.includes(sub) ? "" : sub;
  }

  // 5. Production & general domains (e.g. "delhi-public.yuvaquest.com", "yuvaquest.com")
  const parts = host.split(".");

  // 2 or fewer parts (e.g. "yuvaquest.com") -> root domain
  if (parts.length <= 2) {
    return "";
  }

  const sub = parts[0];
  const reserved = ["www", "admin", "app", "staging"];
  if (reserved.includes(sub)) {
    return "";
  }

  return sub;
}
